module.exports = __webpack_public_path__ + "static/media/girl-talking-on-phone.e8186e24.jpg";